(() => {
  if (window.__awkProductFixes) return;
  window.__awkProductFixes = true;

  const stickySelector = '[data-awk-sticky-buy]';

  function productIdFor(element) {
    if (!(element instanceof Element)) return '';
    const form = element.querySelector('product-form-component[data-product-id]');
    return form ? form.getAttribute('data-product-id') || '' : '';
  }

  function currentProductId() {
    const form = document.querySelector(
      '#MainContent [data-awk-standard-buybox] product-form-component[data-product-id], ' +
      '#MainContent .awk-ap product-form-component[data-product-id]'
    );
    return form ? form.getAttribute('data-product-id') || '' : '';
  }

  function removeSticky(bar) {
    if (!(bar instanceof HTMLElement)) return;
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    bar.remove();
  }

  function cleanStickyBars() {
    const bars = Array.from(document.querySelectorAll(stickySelector)).filter((bar) => bar instanceof HTMLElement);
    if (bars.length < 2) return;

    const currentId = currentProductId();
    const matching = currentId
      ? bars.filter((bar) => {
          const id = productIdFor(bar);
          return id === currentId || id === '';
        })
      : bars;

    let keep = matching.slice().reverse().find((bar) => bar.closest('#MainContent'));
    if (!keep) keep = matching[matching.length - 1] || bars[bars.length - 1];

    bars.forEach((bar) => {
      if (bar === keep) return;
      const isPortal = bar.parentElement === document.body && bar.getAttribute('data-awk-mobile-portal') === 'true';
      if (isPortal) removeSticky(bar);
    });
  }

  let cleanupQueued = false;
  function queueCleanup() {
    if (cleanupQueued) return;
    cleanupQueued = true;
    window.requestAnimationFrame(() => {
      cleanupQueued = false;
      cleanStickyBars();
    });
  }

  function fixBenefitRoles(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.awk-sp__benefits[role="list"]').forEach((list) => {
      list.removeAttribute('role');
      list.querySelectorAll('article[role="listitem"]').forEach((item) => item.removeAttribute('role'));
    });
  }

  function repairReference(element, attribute) {
    const value = element.getAttribute(attribute);
    if (!value) return;

    const ids = value.trim().split(' ').filter(Boolean);
    const valid = ids.filter((id) => document.getElementById(id));

    if (valid.length) element.setAttribute(attribute, valid.join(' '));
    else element.removeAttribute(attribute);
  }

  function fixJudgeMe(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.jdgm-widget [role="tab"], #judgeme_product_reviews [role="tab"]').forEach((tab) => {
      if (tab.id && tab.id.indexOf('jdgm-tab_') === 0) {
        const expectedPanelId = tab.id.replace('jdgm-tab_', 'jdgm-tabpanel_');
        if (document.getElementById(expectedPanelId)) {
          tab.setAttribute('aria-controls', expectedPanelId);
        } else {
          repairReference(tab, 'aria-controls');
        }
      } else {
        repairReference(tab, 'aria-controls');
      }

      repairReference(tab, 'aria-labelledby');
      repairReference(tab, 'aria-describedby');

      const selected = tab.getAttribute('aria-selected');
      if (selected !== null && selected !== 'true' && selected !== 'false') {
        tab.setAttribute('aria-selected', 'false');
      }
    });
  }

  function runFixes(root) {
    cleanStickyBars();
    fixBenefitRoles(root || document);
    fixJudgeMe(root || document);
  }

  function initStickyObserver() {
    if (!(document.body instanceof HTMLBodyElement)) return;

    const observer = new MutationObserver((mutations) => {
      const stickyChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof Element &&
            (node.matches(stickySelector) || Boolean(node.querySelector(stickySelector)))
        )
      );

      if (stickyChanged) queueCleanup();
    });

    observer.observe(document.body, { childList: true });
  }

  function initJudgeMeObserver() {
    let widgetObserver = null;

    const attach = () => {
      const widget = document.getElementById('judgeme_product_reviews');
      if (!(widget instanceof Element)) return false;

      fixJudgeMe(widget);
      if (widgetObserver) return true;

      widgetObserver = new MutationObserver(() => fixJudgeMe(widget));
      widgetObserver.observe(widget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-selected']
      });

      window.setTimeout(() => {
        widgetObserver?.disconnect();
        widgetObserver = null;
      }, 15000);
      return true;
    };

    if (attach()) return;

    const discoveryObserver = new MutationObserver(() => {
      if (!attach()) return;
      discoveryObserver.disconnect();
    });

    if (document.body) {
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => discoveryObserver.disconnect(), 10000);
    }

    [300, 900, 1800, 3200, 6000].forEach((delay) => window.setTimeout(attach, delay));
  }

  function init() {
    runFixes(document);
    initStickyObserver();
    initJudgeMeObserver();

    [100, 400, 1000, 2500, 5000].forEach((delay) => {
      window.setTimeout(() => runFixes(document), delay);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    runFixes(event.target);
    window.setTimeout(queueCleanup, 50);
  });

  document.addEventListener('shopify:section:unload', queueCleanup);

  window.addEventListener('pageshow', () => {
    runFixes(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
